import type { HttpClient } from '@shared/http/http-client';
import type {
  IWorkpieceTypeRepository,
  WorkpieceTypeListQuery,
} from '@domain/data-contracts/workpiece-type-repository.interface';
import type { WorkpieceType } from '@domain/models/workpiece-type.interface';
import type { PagedResult } from '@domain/models/paging.interface';
import {
  mapWorkpieceTypeDto,
  mapPaged,
  type WorkpieceTypeDto,
  type PagedDto,
} from './mapping.helper';

const BASE = '/api/workpiece-types';

export class WorkpieceTypeRepository implements IWorkpieceTypeRepository {
  public constructor(private readonly http: HttpClient) {}

  public async list(query: WorkpieceTypeListQuery): Promise<PagedResult<WorkpieceType>> {
    const response = await this.http.get<PagedDto<WorkpieceTypeDto>>(BASE, {
      params: pruneParams(query),
    });
    return mapPaged(response.data, mapWorkpieceTypeDto);
  }
}

function pruneParams(query: WorkpieceTypeListQuery): Record<string, string | number> {
  const out: Record<string, string | number> = {};
  if (query.search && query.search.trim().length > 0) { out.search = query.search.trim(); }
  if (query.categoryId) { out.categoryId = query.categoryId; }
  if (typeof query.page === 'number') { out.page = query.page; }
  if (typeof query.pageSize === 'number') { out.pageSize = query.pageSize; }
  return out;
}
